export default __webpack_public_path__ + "static/media/support.70e2f9b5.png";